import { Commit } from 'vuex';
import { SuiviInterventionPreventiveState } from './state';

export enum SuiviInterventionPreventiveActions {
    GET_SUIVIS_INTERVENTION = 'GET_SUIVIS_INTERVENTION_PREVENTIVE',
    NAV_FILTER = 'NAV_FILTER_INTERVENTION_PREVENTIVE',
    SET_FILTER = 'SET_FILTER',
    SET_DATE = 'SET_DATE',
    EXPORT_XLS_INTERVENTION_PREVENTIVE = 'EXPORT_XLS_INTERVENTION_PREVENTIVE',
}

export interface SuiviInterventionActionTypes{
    commit: Commit,
    state: SuiviInterventionPreventiveState,
    getters: any
}
